export default "__VITE_ASSET__CtD_cRM6__"